const DATE_FORMATTER = new Intl.DateTimeFormat("es-MX", {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
});

export function formatDate(tstamp: string): string | null {
  try {
    const date = new Date(tstamp);
    return DATE_FORMATTER.format(date);
  } catch (e) {
    return null;
  }
}
